import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-creative",
  "use": "icon-creative-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-creative\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M6,10,3.28,7.3A.93.93,0,0,1,3,6.63,1,1,0,0,1,3.28,6L6,3.28a1,1,0,0,1,1.34,0L10,6ZM14,18l4-4,2.5,2.5v4h-4ZM6,12.67,7.7,14.41,9,13.06,7.3,11.33,8.65,10l1.73,1.73,1.34-1.34L10,8.65,11.33,7.3,13.06,9,14.41,7.7,12.67,6l2.69-2.68a1,1,0,0,1,1.34,0l4,4a1,1,0,0,1,0,1.35L8.65,20.72a1,1,0,0,1-1.35,0l-4-4a1,1,0,0,1,0-1.34Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol